'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');

var dom;
var scrollPosition;

var setupDom = function() {

	dom = {};
	dom.cart = $('.cart');
	dom.cartMainContent = dom.cart.find('.cart__main-content');
	dom.cartMsg = dom.cart.find('.cart__msg');

};

var addEventHandlers = function() {

	appDom.document
		.on('change', '.cart__qty', onItemQuantityChanged)
		.on('click', '.cart__remove-link', onRemoveItemClicked)
		.on('click', '.cart', onCartClicked)
		.on('coupon_applied', onCouponApplied)
		.on('coupon_removed', onCouponRemoved)
		.on('keypress', '.cart__coupon-input', onCouponKeypress)
		.on('click', '.cart__checkout-btn', onCheckoutBtnClicked)
		.on('click', '.cart__confirm-remove-btn', onConfirmRemoveBtnClicked)
		.on('cart_view', openCart);

};

var onRemoveItemClicked = function(e) {

	var $item = $(this).parents('.cart__item');

	e.preventDefault();

	$.ajax({
		type: 'POST',
		url: '?page=cart_update',
		dataType: 'JSON',
		data: {
			quantity: 0,
			cartPosition: $item.attr('data-cart-position')
		}
	}).done(onItemQuantityChangedDone);

};

var onConfirmRemoveBtnClicked = function(e) {

	var $this = $(this);

	e.preventDefault();

	$this.text(window.pbizServer.content.loading);

	$.ajax({
		type: 'POST',
		url: '?page=cart_update',
		dataType: 'JSON',
		data: {
			quantity: 0,
			confirm: true,
			cartPosition: $this.attr('data-cart-position')
		}
	}).done(retrieveCartData);

};

var onCouponKeypress = function(e) {

	if (e.which === 13) {
		dom.cart.find('.cart__apply-coupon-btn').trigger('click');
	}

};

var onCheckoutBtnClicked = function(e) {

	var $link = $(this);

	e.preventDefault();

	$link.text(window.pbizServer.content.loading);

	$.ajax({
		url: $link.attr('href'),
		method: 'POST'
	}).done(onCheckoutBtnClickedDone);

};

var onCheckoutBtnClickedDone = function(response) {

	dom.checkoutBtn = $('.cart__checkout-btn');

	if (response.status.code) {

		window.location = response.destination;

	} else {

		notify.show({
			msg: response.status.msg,
			target: dom.checkoutBtn,
			closeOnClick: true
		});

		dom.checkoutBtn.text(window.pbizServer.content.checkout);

	}

};

var onCouponApplied = function() {

	retrieveCartData();

};

var onCouponRemoved = function() {

	retrieveCartData();

};

var onItemQuantityChanged = function() {

	var $selectBox = $(this);
	var $item = $selectBox.parents('.cart__item');
	var $couponInput = dom.cart.find('.cart__coupon-input');
	var itemLabel = $selectBox.attr('data-item-label');

	$.ajax({
		type: 'POST',
		url: '?page=cart_update',
		dataType: 'JSON',
		data: {
			quantity: $selectBox.val(),
			cartPosition: $item.attr('data-cart-position'),
			couponCode: $couponInput.val(),
			itemLabel: itemLabel
		}
	}).done(onItemQuantityChangedDone);

};

var onItemQuantityChangedDone = function(response) {

	if (response.status.detail === 'confirm_cart_item_removal') {

		// Save the scroll position of the cart in case the cancel button is clicked because we want to go back to exactly where we came from
		scrollPosition = sidePanel.scrollTop();

		sidePanel.open(response.markup);

		// Now that the "confirm removal" markup is in the side panel, attach a one time click handler to the cancel button that will listen once for when the side panel is re-opened with the cart markup, after which we can restore the scroll position manually
		$('.cart__cancel-remove-btn').one('click', function() {

			appDom.document.one('side_panel_opened', function() {

				sidePanel.scrollTop(scrollPosition);

			});

		});

	} else {

		triggerCustomEvent('cart_item_qty_changed');

		retrieveCartData(null, true);

	}

};

var onCartClicked = function(e) {

	notify.hide();

	e.stopPropagation();

};

var openCart = function() {

	retrieveCartData('none');

};

var retrieveCartData = function(backButtonTarget, retainScrollPosition) {

	$.ajax({
		type: 'POST',
		dataType: 'JSON',
		url: '?page=cart_view',
		data: {
			backButtonTarget: backButtonTarget
		}
	}).done(function(response) {

		if (response.status.code === 1) {

			onRetrieveCartDataDone(response, retainScrollPosition);

		} else {

			triggerCustomEvent(response.status.detail, {
				data: {
					response: response
				}
			});

		}

	});

};

var onRetrieveCartDataDone = function(response, retainScrollPosition) {

	sidePanel.open(response.markup, {retainScrollPosition: retainScrollPosition});

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
